import { FormControl, InputAdornment, TextField, useTheme } from "@mui/material";
import { useEffect, useState } from "react";
import { FiSearch } from "react-icons/fi";
import { MdClear } from "react-icons/md";
import { getOrgTokens } from "../../theme/style/organizationPalette";

const SearchBox = ({ text, setText, placeholder = "Search", width = 250 }) => {
  const [showClearIcon, setShowClearIcon] = useState(false);
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const tok = getOrgTokens(isDark);

  const handleChange = (event) => setText(event.target.value);
  const handleClick = () => setText("");

  useEffect(() => setShowClearIcon(text !== ""), [text]);

  return (
    <FormControl onClick={(e) => e.stopPropagation()}>
      <TextField
        size="small"
        variant="outlined"
        onChange={handleChange}
        value={text}
        placeholder={placeholder}
        sx={{
          width: width,
          "& .MuiOutlinedInput-root": {
            height: 40,
            paddingX: 0.5,
            paddingLeft: 1,
            fontFamily: "Poppins",
            borderRadius: "12px",
            "& .MuiOutlinedInput-notchedOutline": {
              borderRadius: "12px",
              borderColor: tok.border.divider,
            },
            "&:hover": {
              "& .MuiOutlinedInput-notchedOutline": { borderColor: "#16a34a" },
            },
            "&.Mui-focused": {
              "& .MuiOutlinedInput-notchedOutline": { borderColor: "#16a34a", borderWidth: "2px" },
            },
          },
        }}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start" sx={{ padding: 1.2 }}>
              <FiSearch />
            </InputAdornment>
          ),
          endAdornment: (
            <InputAdornment
              position="end"
              sx={{
                visibility: showClearIcon ? "visible" : "hidden",
                padding: 1.2,
                borderRadius: 2,
                "&:hover": {
                  color: "#16a34a",
                  backgroundColor: "rgba(22, 163, 74, 0.1)",
                  opacity: 1,
                  cursor: "pointer",
                },
              }}
              onClick={handleClick}>
              <MdClear />
            </InputAdornment>
          ),
        }}
      />
    </FormControl>
  );
};

export default SearchBox;
